import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { DialogSiteCreatedComponent } from '@app/modules/direct/dialogs/dialog-site-created/dialog-site-created.component';
import { DirectSiteContentService } from '@app/modules/direct/services/direct-content.service';
import { DirectEditService } from '@app/modules/direct/services/direct-edit.service';
import { DirectService, FullTemplate } from '@app/modules/direct/services/direct.service';
import { DeviceDetectionService } from '@app/shared/services/device-detection/device-detection.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  standalone: false,
  selector: 'sbnb-direct-edit-overview',
  templateUrl: './direct-edit-overview.component.html',
})
export class DirectEditOverviewComponent implements OnDestroy, OnInit {
  templates: FullTemplate[] = [];
  iframeSrc: SafeResourceUrl;
  destroy$ = new Subject<void>();

  isMobile$ = this.deviceDetectionService.isMobileViewport();

  constructor(
    public readonly directEditService: DirectEditService,
    public readonly directSiteContentService: DirectSiteContentService,
    private readonly direct: DirectService,
    private readonly sanitizer: DomSanitizer,
    private readonly dialog: MatDialog,
    private readonly route: ActivatedRoute,
    private readonly deviceDetectionService: DeviceDetectionService
  ) {}

  ngOnInit(): void {
    this.getTemplates();

    this.directSiteContentService.refreshIframe$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.directEditService.site.preview_url);
    });

    this.directSiteContentService.init(this.directEditService.site.id);

    if (this.route.snapshot.paramMap.get('siteAdded')) {
      const ref = this.dialog.open(DialogSiteCreatedComponent, {
        width: '400px',
      });

      ref.afterClosed().subscribe((result) => {
        if (result === 'publish') this.directEditService.publishSite();
      });
    }
  }

  ngOnDestroy() {
    this.directSiteContentService.destroy(this.directEditService.site.id);
    this.destroy$.next();
  }

  getTemplates() {
    this.direct.getSiteTemplates().subscribe((templates) => (this.templates = templates));
  }

  updateSiteTemplate(templateId: string) {
    if (this.directEditService.site.template !== templateId) {
      this.directSiteContentService.loading = true;

      this.direct.switchSiteTemplate(this.directEditService.site.id, templateId).subscribe({
        next: () => this.directEditService.setSite({ template: templateId }),
        error: () => (this.directSiteContentService.loading = false),
      });
    }
  }
}
